import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconArrowRight = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-arrow-right" data-icon="icon-arrow-right" aria-hidden="true" {...props} ref={ref}><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>);
});

IconArrowRight.displayName = 'IconArrowRight';
